import { useEffect, useState } from "react"
import ModalEditTask from "../modalEditTask/modalEditTask";
import { Avatar, AvatarBadge, AvatarGroup } from '@chakra-ui/react'
import EditStatus from "./editStatus/editStatus";
import ButtonDeleteTask from "./buttonDeleteTask";
import EditPrioritet from "./editPrioritet/editPrioritet";
import ChangeDate from "./changeDate/changeDate";
import DropdownMobileStatus from "./EditStatusForMobile/editStatusForMobile";
import { useToast } from '@chakra-ui/react'
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import ButtonDeleteSubtaskTask from "./buttonDeleteSubTask";
import sockets from "../../../../socket/socket";
import EditStatusBySelect from "./editStatusBySelect/editStatusBySelect";
import EditPrioritySelect from "./editPrioritySelect/editPrioritySelect";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Button,
  Portal
} from '@chakra-ui/react'

const socket = sockets


export default function Tr({ item, update, data, handleGetNotify, index, allitem, onlineUsers }) {

  const [showSubRows, setShowSubRows] = useState(false);
  const [mouts, setmounts] = useState(["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"])
  const [currentDate, setcurrentDate] = useState("")
  const toast = useToast()
  const navigate = useNavigate()
  let onlineUSers = useSelector(onlineUSers => onlineUSers)
  const getDarkModoe = useSelector(darkModes => darkModes);


  const toggleSubRows = () => {
    setShowSubRows(!showSubRows);
  };
  let endDate = item.alltask[0]?.endDate
  useEffect(() => {
    let date = new Date(endDate)
    let mount = mouts[date.getMonth()]
    let getHours = date.getHours()
    let getMinuts = date.getMinutes()
    let getDey = date.getDay()
    setcurrentDate(`${getDey}  ${mount} ., ${getHours}:${getMinuts}`)



  }, [])

  function Copytex(text = "Gor") {
    console.log('text', text)
    var textField = document.createElement('textarea')
    textField.innerText = "http://localhost:3000/getCurrentTask/" + allitem._id
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    toast({
      position: "top",
      title: 'Ссылка на задачу скопирована.',
      description: "Ссылка на задачу скопирована.",
      status: 'success',
      duration: 1000,
      isClosable: true,
    })


  }



  return (
    <>
      <tr >
        <td>
          <Popover placement="right" >
            <PopoverTrigger>
              <button >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </PopoverTrigger>
            <Portal>
              <PopoverContent  className={getDarkModoe.ToggleDarkModeReducer.chekced ? "PopoverTaskBTNDark" : "PopoverTaskBTN"} width={'243px'} border={"1px solid rgba(0, 0, 0, 0.10)"} borderRadius={"12px"} overflow={"hidden"} >
                <div className="taskBtn">
                  <div>

                    <div>

                      <div onClick={Copytex}>
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M14 11.9976C14 9.5059 11.683 7 8.85714 7C8.52241 7 7.41904 7.00001 7.14286 7.00001C4.30254 7.00001 2 9.23752 2 11.9976C2 14.376 3.70973 16.3664 6 16.8714C6.36756 16.9525 6.75006 16.9952 7.14286 16.9952" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10 11.9976C10 14.4893 12.317 16.9952 15.1429 16.9952C15.4776 16.9952 16.581 16.9952 16.8571 16.9952C19.6975 16.9952 22 14.7577 22 11.9976C22 9.61921 20.2903 7.62885 18 7.12384C17.6324 7.04279 17.2499 7 16.8571 7" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <p>Скопировать ссылку</p>
                        </div>

                      </div>
                      <div onClick={() => navigate("/getCurrentTask/" + item._id)}>
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M1.5 19H10.5H19.5" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10.7276 3.82843L15.6774 8.77814M10.7276 3.82843L13.5561 1L18.5058 5.94975L15.6774 8.77814L10.7276 3.82843ZM10.7276 3.82843L5.12102 9.43504C4.93349 9.62254 4.82812 9.87694 4.82812 10.1421V14.6776H9.36369C9.62889 14.6776 9.88319 14.5723 10.0708 14.3847L15.6774 8.77814L10.7276 3.82843Z" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <p>Редактировать</p>
                        </div>

                      </div>
                      <ButtonDeleteTask item={item} index={index} key={index} />
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Portal>
          </Popover>

        </td>
        <td style={{ textAlign: 'center' }}>
          {
            showSubRows ?
              <button onClick={() => toggleSubRows()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7.41 8.29504L12 12.875L16.59 8.29504L18 9.70504L12 15.705L6 9.70504L7.41 8.29504Z" fill="#BEC2CC" />
                </svg>
              </button>
              :
              <button onClick={() => toggleSubRows()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z" fill="#BEC2CC" />
                </svg>
              </button>

          }

        </td>
        <td >
          <div className="taskNameAndIcons">
            <p onClick={() => navigate("/getCurrentTask/" + item._id)}>{item.alltask[0].taskName}</p>
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" className="countComment">
                <path d="M5.88889 1.09589H3.93333C2.90657 1.09589 2.39319 1.09589 2.00102 1.29074C1.65605 1.46213 1.37559 1.73561 1.19982 2.07198C1 2.45439 1 2.95499 1 3.95618V7.05482C1 7.60899 1 7.88607 1.06247 8.1134C1.23199 8.73032 1.72616 9.21218 2.35883 9.37748C2.59197 9.4384 2.87613 9.4384 3.44444 9.4384V10.8301C3.44444 11.1476 3.44444 11.3064 3.5112 11.3879C3.56925 11.4588 3.65728 11.5001 3.75033 11.5C3.85733 11.4999 3.98447 11.4007 4.23874 11.2024L5.69652 10.0652C5.99432 9.83287 6.14321 9.71672 6.30902 9.63412C6.45612 9.56084 6.61271 9.50728 6.77452 9.4749C6.95691 9.4384 7.14759 9.4384 7.52896 9.4384H8.45556C9.48232 9.4384 9.9957 9.4384 10.3879 9.24355C10.7328 9.07216 11.0133 8.79868 11.1891 8.46231C11.3889 8.0799 11.3889 7.5793 11.3889 6.57811V6.45893M11.463 1.0236C12.179 1.72173 12.179 2.85363 11.463 3.55176C10.7471 4.24989 9.58627 4.24989 8.8703 3.55176C8.15434 2.85363 8.15434 1.72173 8.8703 1.0236C9.58627 0.325467 10.7471 0.325467 11.463 1.0236Z" stroke="#BEC2CC" strokeLinejoin="round" />
              </svg> */}
            {/* {item.alltask[0].comments.length} */}
            {/* <div style={{ display: "flex" }} >
        
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30" fill="none" onClick={() => navigate("/getCurrentTask/" + item._id)}>
                  <g filter="url(#filter0_d_1111_4714)">
                    <ellipse cx="14" cy="13" rx="11" ry="11.25" fill="white" />
                  </g>
                  <path d="M15.6795 10.2756L16.3183 10.929L10.0275 17.3636H9.3887V16.7102L15.6795 10.2756ZM18.1791 6C18.0056 6 17.825 6.07102 17.6931 6.20597L16.4224 7.50568L19.0262 10.169L20.2969 8.86932C20.5677 8.59233 20.5677 8.14489 20.2969 7.8679L18.6721 6.20597C18.5333 6.06392 18.3597 6 18.1791 6ZM15.6795 8.26562L8 16.1207V18.7841H10.6038L18.2833 10.929L15.6795 8.26562Z" fill="#3B79F6" />
                  <defs>
                    <filter id="filter0_d_1111_4714" x="0" y="0.75" width="28" height="28.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="1.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1111_4714" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1111_4714" result="shape" />
                    </filter>
                  </defs>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30" fill="none" onClick={Copytex}>
                  <g filter="url(#filter0_d_1180_4179)">
                    <ellipse cx="14" cy="13" rx="11" ry="11.25" fill="white" />
                  </g>
                  <path d="M17.309 14.8828C16.9436 14.8837 16.5835 14.971 16.2582 15.1375C15.9329 15.3041 15.6517 15.5453 15.4374 15.8413L12.5242 13.8994C12.7078 13.4099 12.7078 12.8704 12.5242 12.3809L15.4374 10.439C15.7643 10.8823 16.2387 11.1945 16.7752 11.3194C17.3117 11.4444 17.8751 11.3739 18.3643 11.1207C18.8535 10.8675 19.2364 10.4481 19.4442 9.93797C19.6519 9.42781 19.671 8.86027 19.4979 8.33734C19.3247 7.8144 18.9708 7.37034 18.4997 7.08494C18.0285 6.79954 17.471 6.6915 16.9274 6.78024C16.3837 6.86898 15.8895 7.14867 15.5336 7.56908C15.1776 7.98948 14.9833 8.52303 14.9854 9.07388C14.9892 9.15852 14.9977 9.24288 15.011 9.32657L11.8794 11.4143C11.5456 11.1135 11.1318 10.9158 10.6881 10.8453C10.2443 10.7748 9.78965 10.8345 9.37912 11.0172C8.96859 11.1998 8.61982 11.4975 8.37505 11.8743C8.13028 12.2511 8 12.6908 8 13.1401C8 13.5895 8.13028 14.0292 8.37505 14.4059C8.61982 14.7827 8.96859 15.0805 9.37912 15.2631C9.78965 15.4458 10.2443 15.5054 10.6881 15.435C11.1318 15.3645 11.5456 15.1668 11.8794 14.866L15.011 16.9537C14.9977 17.0374 14.9892 17.1218 14.9854 17.2064C14.9854 17.666 15.1217 18.1152 15.377 18.4973C15.6323 18.8794 15.9952 19.1773 16.4198 19.3531C16.8444 19.529 17.3116 19.575 17.7623 19.4854C18.2131 19.3957 18.6271 19.1744 18.952 18.8494C19.277 18.5245 19.4983 18.1105 19.5879 17.6597C19.6776 17.209 19.6316 16.7418 19.4557 16.3172C19.2799 15.8926 18.982 15.5297 18.5999 15.2744C18.2178 15.0191 17.7686 14.8828 17.309 14.8828Z" fill="#6B7A99" />
                  <defs>
                    <filter id="filter0_d_1180_4179" x="0" y="0.75" width="28" height="28.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="1.5" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1180_4179" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1180_4179" result="shape" />
                    </filter>
                  </defs>
                </svg>
                <ButtonDeleteTask item={item} index={index} key={index} />
              </div> */}

          </div>

        </td>
        <td >
          <div className="marketplace">
            <div>
              {/* item.alltask[0].ozon.length > 0 */}
              {
                (item.alltask[0].ozon.length > 0) ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="26" viewBox="0 0 23 26" fill="none">
                    <path d="M4.18901 7.22727H6.39071L7.81117 10.1818H7.86799L9.28844 7.22727H11.4901L8.81969 12.2131V14.5H6.85946V12.2131L4.18901 7.22727Z" fill="white" />
                    <path d="M12.1338 7.22727H14.5912L16.2815 11.3466H16.3667L18.0571 7.22727H20.5145V14.5H18.5827V10.2955H18.5258L16.9065 14.4432H15.7417L14.1224 10.267H14.0656V14.5H12.1338V7.22727Z" fill="white" />
                    <path d="M4 21C4 20.7239 4.22386 20.5 4.5 20.5H20.5C20.7761 20.5 21 20.7239 21 21C21 21.2761 20.7761 21.5 20.5 21.5H4.5C4.22386 21.5 4 21.2761 4 21Z" fill="white" />
                    <path d="M0 3.5C0 1.84315 1.34315 0.5 3 0.5H20C21.6569 0.5 23 1.84315 23 3.5V22.5C23 24.1569 21.6569 25.5 20 25.5H3C1.34315 25.5 0 24.1569 0 22.5V3.5Z" fill="#005CFF" />
                    <path d="M11.563 10.8636C11.563 11.6733 11.4056 12.3563 11.0907 12.9126C10.7759 13.4666 10.3509 13.8868 9.81587 14.1733C9.28084 14.4574 8.68425 14.5994 8.0261 14.5994C7.36322 14.5994 6.76426 14.4562 6.22923 14.1697C5.69656 13.8809 5.27279 13.4595 4.95792 12.9055C4.64542 12.3492 4.48917 11.6686 4.48917 10.8636C4.48917 10.054 4.64542 9.37216 4.95792 8.81818C5.27279 8.26184 5.69656 7.84162 6.22923 7.55753C6.76426 7.27107 7.36322 7.12784 8.0261 7.12784C8.68425 7.12784 9.28084 7.27107 9.81587 7.55753C10.3509 7.84162 10.7759 8.26184 11.0907 8.81818C11.4056 9.37216 11.563 10.054 11.563 10.8636ZM9.53178 10.8636C9.53178 10.428 9.47378 10.0611 9.35778 9.76278C9.24414 9.46212 9.07487 9.23485 8.84997 9.08097C8.62743 8.92472 8.35281 8.84659 8.0261 8.84659C7.6994 8.84659 7.42359 8.92472 7.19869 9.08097C6.97615 9.23485 6.80688 9.46212 6.69087 9.76278C6.57724 10.0611 6.52042 10.428 6.52042 10.8636C6.52042 11.2992 6.57724 11.6674 6.69087 11.968C6.80688 12.2663 6.97615 12.4936 7.19869 12.6499C7.42359 12.8037 7.6994 12.8807 8.0261 12.8807C8.35281 12.8807 8.62743 12.8037 8.84997 12.6499C9.07487 12.4936 9.24414 12.2663 9.35778 11.968C9.47378 11.6674 9.53178 11.2992 9.53178 10.8636Z" fill="white" />
                    <path d="M12.505 14.5V13.4062L15.9425 8.81818H12.5192V7.22727H18.4567V8.32102L15.0192 12.9091H18.4425V14.5H12.505Z" fill="white" />
                    <path d="M4 21C4 20.7239 4.22386 20.5 4.5 20.5H18.5C18.7761 20.5 19 20.7239 19 21C19 21.2761 18.7761 21.5 18.5 21.5H4.5C4.22386 21.5 4 21.2761 4 21Z" fill="white" />
                  </svg>
                  :
                  ""
              }
              {/* item.alltask[0].wb.length > 0 */}
              {
                (item.alltask[0].wb.length > 0) ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <path d="M0 3.5C0 1.84315 1.34315 0.5 3 0.5H23C24.6569 0.5 26 1.84315 26 3.5V22.5C26 24.1569 24.6569 25.5 23 25.5H3C1.34315 25.5 0 24.1569 0 22.5V3.5Z" fill="#8A27D8" />
                    <path d="M6.50675 14.5L4.36186 7.22727H6.56357L7.55788 11.7017H7.6147L8.79368 7.22727H10.5266L11.7056 11.7159H11.7624L12.7567 7.22727H14.9585L12.8136 14.5H10.9244L9.68857 10.4375H9.63175L8.39595 14.5H6.50675Z" fill="white" />
                    <path d="M15.5977 14.5V7.22727H18.7511C19.305 7.22727 19.7702 7.30185 20.1467 7.45099C20.5254 7.60014 20.8107 7.81084 21.0025 8.0831C21.1966 8.35535 21.2937 8.67614 21.2937 9.04545C21.2937 9.31297 21.2345 9.55682 21.1161 9.77699C21.0001 9.99716 20.8368 10.1818 20.6261 10.331C20.4154 10.4777 20.1692 10.5795 19.8874 10.6364V10.7074C20.1999 10.7192 20.484 10.7985 20.7397 10.9453C20.9954 11.0897 21.199 11.2898 21.3505 11.5455C21.502 11.7988 21.5778 12.0971 21.5778 12.4403C21.5778 12.8381 21.4736 13.192 21.2653 13.5021C21.0593 13.8123 20.7657 14.0561 20.3846 14.2337C20.0034 14.4112 19.5489 14.5 19.021 14.5H15.5977ZM17.5721 12.9233H18.4954C18.8268 12.9233 19.0754 12.8617 19.2411 12.7386C19.4068 12.6132 19.4897 12.4285 19.4897 12.1847C19.4897 12.0142 19.4506 11.8698 19.3725 11.7514C19.2944 11.633 19.1831 11.5431 19.0387 11.4815C18.8967 11.42 18.725 11.3892 18.5238 11.3892H17.5721V12.9233ZM17.5721 10.1676H18.3817C18.5546 10.1676 18.7073 10.1404 18.8398 10.0859C18.9724 10.0315 19.0754 9.95336 19.1488 9.85156C19.2245 9.7474 19.2624 9.62074 19.2624 9.47159C19.2624 9.24669 19.1819 9.07505 19.021 8.95668C18.86 8.83594 18.6564 8.77557 18.4102 8.77557H17.5721V10.1676Z" fill="white" />
                    <path d="M4 21C4 20.7239 4.22386 20.5 4.5 20.5H21.5C21.7761 20.5 22 20.7239 22 21C22 21.2761 21.7761 21.5 21.5 21.5H4.5C4.22386 21.5 4 21.2761 4 21Z" fill="white" />
                  </svg>
                  :
                  ""
              }

            </div>




          </div>

        </td>
        <td>
          <div className="perfomerInfo">
            {
              onlineUSers.getOnlineUserViaRouterReducer.users.data?.find((user) => user === item.alltask[0].perfomerID[0]?.workerID)
                ? <Avatar size='md' src={item.alltask[0].perfomerID[0]?.img ? item.alltask[0].perfomerID[0]?.img : "https://bit.ly/broken-link"} style={{ marginRight: "10px" }}>
                  <AvatarBadge boxSize='0.9em' bg='green.500' />
                </Avatar>
                : <Avatar size='md' src={item.alltask[0].perfomerID[0]?.img ? item.alltask[0].perfomerID[0]?.img : "https://bit.ly/broken-link"} style={{ marginRight: "10px" }} />
            }



            <div>
              <p>{item.alltask[0].perfomerID[0]?.name}</p>
              <p>{item.alltask[0].perfomerID[0]?.tel}</p>
            </div>
          </div>
        </td>
        <td >
          <ChangeDate item={item} isChild={false} currentDate={currentDate} allitemForStatus={allitem} index={index} update={update} key={index + allitem} />
        </td>
        <td className="PRIORITY">
          <EditPrioritySelect isChild={false} prioritetGet={item.alltask[0].prioritet} allitemForStatus={allitem} index={index} update={update} />
          {/* <EditPrioritet isChild={false} prioritetGet={item.alltask[0].prioritet} allitemForStatus={allitem} index={index} update={update} /> */}
        </td>
        <td className="statusTD">
          <EditStatusBySelect isChild={false} statusGet={item.alltask[0].status} allitemForStatus={allitem} index={index} update={update} />
          {/* <EditStatus isChild={false} statusGet={item.alltask[0].status} allitemForStatus={allitem} index={index} update={update} /> */}
        </td>
        <td>
          <div className="priceTaskTable">
            <input type="number" defaultValue={0} />
          </div>
        </td>


      </tr>
      {
        (() => {
          if (showSubRows) {
            // SUBTASK====================================================================================
            return item.alltask[0]?.child?.map((items, indexs) => {


              return (
                <tr key={indexs} className="subTaskTr">
                  <td>
                    <Popover placement="right">
                      <PopoverTrigger>
                        <button >
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z" fill="#0F172A" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent className="PopoverTaskBTN" width={'243px'} border={"1px solid rgba(0, 0, 0, 0.10)"} borderRadius={"12px"} overflow={"hidden"}>
                          <div className="taskBtn" >
                            <div>

                              <div>

                                <div onClick={Copytex}>
                                  <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M14 11.9976C14 9.5059 11.683 7 8.85714 7C8.52241 7 7.41904 7.00001 7.14286 7.00001C4.30254 7.00001 2 9.23752 2 11.9976C2 14.376 3.70973 16.3664 6 16.8714C6.36756 16.9525 6.75006 16.9952 7.14286 16.9952" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      <path d="M10 11.9976C10 14.4893 12.317 16.9952 15.1429 16.9952C15.4776 16.9952 16.581 16.9952 16.8571 16.9952C19.6975 16.9952 22 14.7577 22 11.9976C22 9.61921 20.2903 7.62885 18 7.12384C17.6324 7.04279 17.2499 7 16.8571 7" stroke="#3B79F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>Скопировать ссылку</p>
                                  </div>

                                </div>
                                <div onClick={() => navigate("/editChild/" + item._id + "/" + indexs)}>
                                  <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                      <path d="M1.5 19H10.5H19.5" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      <path d="M10.7276 3.82843L15.6774 8.77814M10.7276 3.82843L13.5561 1L18.5058 5.94975L15.6774 8.77814L10.7276 3.82843ZM10.7276 3.82843L5.12102 9.43504C4.93349 9.62254 4.82812 9.87694 4.82812 10.1421V14.6776H9.36369C9.62889 14.6776 9.88319 14.5723 10.0708 14.3847L15.6774 8.77814L10.7276 3.82843Z" stroke="#353535" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p>Редактировать</p>
                                  </div>

                                </div>
                                <ButtonDeleteSubtaskTask item={item} indexParent={index} indexChild={indexs} key={indexs} />
                              </div>
                            </div>
                          </div>
                        </PopoverContent>
                      </Portal>
                    </Popover>
                  </td>
                  <td >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" style={{ margin: "auto" }}>
                      <path fill-rule="evenodd" clipRule="evenodd" d="M22.29 18.71L17.71 23.29C17.32 23.68 16.68 23.68 16.29 23.29C15.9 22.9 15.9 22.26 16.29 21.87L19.17 19H9C8.45 19 8 18.55 8 18V8C8 7.45 8.45 7 9 7C9.55 7 10 7.45 10 8V17H19.17L16.29 14.13C15.9 13.74 15.9 13.1 16.29 12.71C16.68 12.32 17.32 12.32 17.71 12.71L22.29 17.29C22.68 17.68 22.68 18.32 22.29 18.71Z" fill="#C3CAD9" />
                    </svg>
                  </td>
                  <td>
                    <div className="taskNameAndIcons">

                      <div>
                        <p  onClick={() => navigate("/editChild/" + item._id + "/" + indexs)}>{item.alltask[0]?.child[indexs]?.msg}</p>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" className="countComment">
                          <path d="M5.88889 1.09589H3.93333C2.90657 1.09589 2.39319 1.09589 2.00102 1.29074C1.65605 1.46213 1.37559 1.73561 1.19982 2.07198C1 2.45439 1 2.95499 1 3.95618V7.05482C1 7.60899 1 7.88607 1.06247 8.1134C1.23199 8.73032 1.72616 9.21218 2.35883 9.37748C2.59197 9.4384 2.87613 9.4384 3.44444 9.4384V10.8301C3.44444 11.1476 3.44444 11.3064 3.5112 11.3879C3.56925 11.4588 3.65728 11.5001 3.75033 11.5C3.85733 11.4999 3.98447 11.4007 4.23874 11.2024L5.69652 10.0652C5.99432 9.83287 6.14321 9.71672 6.30902 9.63412C6.45612 9.56084 6.61271 9.50728 6.77452 9.4749C6.95691 9.4384 7.14759 9.4384 7.52896 9.4384H8.45556C9.48232 9.4384 9.9957 9.4384 10.3879 9.24355C10.7328 9.07216 11.0133 8.79868 11.1891 8.46231C11.3889 8.0799 11.3889 7.5793 11.3889 6.57811V6.45893M11.463 1.0236C12.179 1.72173 12.179 2.85363 11.463 3.55176C10.7471 4.24989 9.58627 4.24989 8.8703 3.55176C8.15434 2.85363 8.15434 1.72173 8.8703 1.0236C9.58627 0.325467 10.7471 0.325467 11.463 1.0236Z" stroke="#BEC2CC" strokeLinejoin="round" />
                        </svg>
                        {item.alltask[0]?.child[indexs]?.comments.length} */}
                      </div>
                    </div>

                  </td>
                  <td></td>
                  <td>

                    <div className="perfomerInfo">
                      {/* {
                         onlineUSers.getOnlineUserViaRouterReducer.users.data?.find((user) => user === item.alltask[0]?.child[indexs]?.performer?.workerID)
                          ? <Avatar size='md' src={item.alltask[0].child[indexs]?.performer.img?item.alltask[0].child[indexs]?.performer.img:"https://bit.ly/broken-link"} style={{ marginRight: "10px" }}>
                            <AvatarBadge boxSize='0.9em' bg='green.500' />
                          </Avatar>
                          : <Avatar size='md'  src={item.alltask[0].child[indexs]?.performer.img?item.alltask[0].child[indexs]?.performer.img:"https://bit.ly/broken-link"} style={{ marginRight: "10px" }} />
                      } */}

                      {
                        (() => {
                          if (item.alltask[0]?.child[indexs]?.performer) {
                            if (onlineUSers.getOnlineUserViaRouterReducer.users.data?.find((user) => user === item.alltask[0]?.child[indexs]?.performer?.workerID)) {
                              return <Avatar size='md' src={item.alltask[0].child[indexs]?.performer.img ? item.alltask[0].child[indexs]?.performer.img : "https://bit.ly/broken-link"} style={{ marginRight: "10px" }}>
                                <AvatarBadge boxSize='0.9em' bg='green.500' />
                              </Avatar>
                            } else {
                              return <Avatar size='md' src={item.alltask[0].child[indexs]?.performer.img ? item.alltask[0].child[indexs]?.performer.img : "https://bit.ly/broken-link"} style={{ marginRight: "10px" }} />
                            }
                          }
                        })()
                      }


                      <div>
                        <p>{item.alltask[0].child[indexs].performer?.name}</p>
                        <p>{item.alltask[0].child[indexs].performer?.tel}</p>
                        <p>{item.alltask[0].child[indexs].performer?.email}</p>
                      </div>
                    </div>

                  </td>
                  <td >
                    <ChangeDate item={item} isChild={true} currentDate={currentDate} allitemForStatus={allitem} index={indexs} update={update} key={index + allitem} />
                  </td>
                  <td className="subPrioritet">

                    {
                      (() => {
                        if (items.prioritet == "") {

                          return <EditPrioritySelect isChild={true} prioritetGet={"Низший"} allitemForStatus={allitem} index={indexs} update={update} />
                          // return <EditPrioritet isChild={true} prioritetGet={"Низший"} allitemForStatus={allitem} index={indexs} update={update} />
                        } else {
                          return <EditPrioritySelect isChild={true} prioritetGet={items.prioritet} allitemForStatus={allitem} index={indexs} update={update} />
                          // return <EditPrioritet isChild={true} prioritetGet={items.prioritet} allitemForStatus={allitem} index={indexs} update={update} />
                        }
                      })()
                    }

                  </td>
                  <td className="subStatus">

                    {
                      (() => {
                        if (items.status == "") {
                          // return <EditStatus isChild={true} statusGet={"Запланирована"} allitemForStatus={allitem} index={indexs} update={update} />
                          return <EditStatusBySelect isChild={true} statusGet={"Запланирована"} allitemForStatus={allitem} index={indexs} update={update} />
                        } else {
                          // return <EditStatus isChild={true} statusGet={items.status} allitemForStatus={allitem} index={indexs} update={update} />
                          return <EditStatusBySelect isChild={true} statusGet={items.status} allitemForStatus={allitem} index={indexs} update={update} />
                        }
                      })()
                    }

                  </td>
                  <td>
                    <div className="priceTaskTable">
                      <input type="number" defaultValue={0} />
                    </div>
                  </td>


                </tr>
              )
            })
          }
        })()
      }


    </>
  )
}
